import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/Payment.css";
import "./Css/Payment-responsive.css";

import { Ripple } from "primereact/ripple";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from "primereact/dropdown";

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import NumberInput from "../../Components/NumberInput";
import FileInput from "../../Components/FileInput";
import DatePicker from "../../Components/DatePicker";
import DocumentViewModal from "../../Components/DocumentViewModal";
import { goToTop } from "../../Components/goToTop";
import { baseURL } from "../../Api/ApiConstant";
import { getAppCurrencyType } from "../../Utils/Common";
import { formatDate } from "../../Utils/getDate";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { getAllPaymentInstalment } from "../../Controllers/Thunks/PaymentThunks";
import { Instalment } from "../../Controllers/Types/SiteMenuModel/Payment/Instalment";
import { fetchAllProjects } from "../../Controllers/Thunks/projectThunks";
import { Project } from "../../Controllers/Types/Project/ProjectInterface";
import { createInstalmentService, deleteInstalmentService, updateInstalmentService } from "../../Api/HeyTraderService/PaymentApiService";
import { checkFileOthers, checkModelSelected, checkNumber, checkText } from "../../Utils/Validator";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { format } from "date-fns";
import { FileUpload } from "primereact/fileupload";
import TextInput from "../../Components/TextInput";
import GoBackButton from "../../Components/GoBackButton";

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const dataLoading = useAppSelector((state) => state?.paymentInstalment?.loader);
  const error = useAppSelector((state) => state?.paymentInstalment?.errorDisplay);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);
  const dialogRef = useRef<Dialog>(null);

  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const menuRefs = useRef<Record<number, Menu | null>>({});
  const buttonRefs = useRef<Record<number, HTMLButtonElement | null>>({});

  const [instalmentFilterState, setInstalmentFilterState] = useState<"All" | "Paid" | "Unpaid" | "Draft">("All");
  const [showPaymentModal, setShowPaymentmodal] = useState<boolean>(false);
  const [showInstalmentViewModal, setShowInstalmentViewModal] = useState<boolean>(false);
  const [instalmentData, setInstalmentData] = useState<Instalment[]>([]);
  const [filteredInstalmentData, setFilteredInstalmentData] = useState<Instalment[]>([]);
  const [selectedInstalment, setSelectedInstalment] = useState<Instalment | null>(null);
  const [instalmentSearchKey, setInstalmentSearchKey] = useState<string>("");
  const [allInvoiceCount, setAllInvoiceCount] = useState<number>(0);
  const [paidInvoiceCount, setPaidInvoiceCount] = useState<number>(0);
  const [unpaidInvoiceCount, setUnpaidInvoiceCount] = useState<number>(0);
  const [dueInvoiceCount, setDueInvoiceCount] = useState<number>(0);
  const [showInvoiceViewModal, setShowInvoiceViewModal] = useState<boolean>(false);
  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const [updateHasChanges, setUpdateHasChanges] = useState<boolean>(false);

  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [invoiceNumber, setInvoiceNumber] = useState<string>("1");
  const [instalmentAmount, setInstalmentAmount] = useState<number | null>(null);
  const [invoiceDate, setInvoiceDate] = useState<Nullable<Date>>(null);
  const [paymentDate, setPaymentDate] = useState<Nullable<Date>>(null);
  const [invoiceFileURL, setInvoiceFileURL] = useState<string | null>(null);

  const [projectError, setProjectError] = useState<string>("");
  const [instalmentAmountError, setInstalmentAmountError] = useState<string>("");
  const [invoiceDateError, setInvoiceDateError] = useState<string>("");
  const [paymentDateError, setPaymentDateError] = useState<string>("");
  const [invoiceNumberError, setInvoiceNumberError] = useState<string>("");
  const [invoiceFileURLError, setInvoiceFileURLError] = useState<string>("");

  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const hasPermissionAddInvoice = useCanEdit("Payment", "create_instalment");
  const hasPermissionEditInvoice = useCanEdit("Payment", "edit_instalment");
  const hasPermissionDeleteInvoice = useCanEdit("Payment", "delete_instalment");

  // for the resons
  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    fetchPaymentInstalmentsData();
    fetchProjectsData();
  }, [dispatch]);

  const fetchPaymentInstalmentsData = async () => {
    await dispatch(getAllPaymentInstalment());
    setInitialDataLoading(false);
  }

  const fetchProjectsData = async () => {
    await dispatch(fetchAllProjects());
  }

  // this is get data from state list and set projectlist
  const payments = useAppSelector((state) => state.paymentInstalment.payments);

  // get all projects
  const projectList = useAppSelector((state) => state.project.allProjects);
  const loadingProjects = useAppSelector((state) => state.project.loading);

  useEffect(() => {
    setInstalmentData(payments?.instalments!);
    setInvoiceNumber(payments?.next_invoice_no!);
  }, [payments]);

  useEffect(() => {
    setProjectsData(projectList);
  }, [projectList]);

  useEffect(() => {
    if (instalmentData && instalmentData?.length > 0) {
      const allCount = instalmentData.length;
      const paidCount = instalmentData.filter((instalment) => instalment?.status === "Paid").length;
      const unpaidCount = instalmentData.filter((instalment) => instalment?.status === "Unpaid").length;
      const draftCount = instalmentData.filter((instalment) => instalment?.status === "Due").length;

      setAllInvoiceCount(allCount);
      setPaidInvoiceCount(paidCount);
      setUnpaidInvoiceCount(unpaidCount);
      setDueInvoiceCount(draftCount);
    } else {
      setAllInvoiceCount(0);
      setPaidInvoiceCount(0);
      setUnpaidInvoiceCount(0);
      setDueInvoiceCount(0);
    }
  }, [instalmentData]);

  useEffect(() => {
    if (!instalmentData || instalmentData.length === 0) {
      setFilteredInstalmentData([]);
      setAllInvoiceCount(0);
      setPaidInvoiceCount(0);
      setUnpaidInvoiceCount(0);
      setDueInvoiceCount(0);
      return;
    }

    const searchKey = instalmentSearchKey.toLowerCase();

    const searchedData = instalmentData.filter((instalment) => {
      const jobMatch = instalment.job_number?.toLowerCase().includes(searchKey);
      const addressMatch = instalment.address?.toLowerCase().includes(searchKey);
      return jobMatch || addressMatch;
    });

    const allCount = searchedData.length;
    const paidCount = searchedData.filter((i) => i.status === "Paid").length;
    const unpaidCount = searchedData.filter((i) => i.status === "Unpaid").length;
    const draftCount = searchedData.filter((i) => i.status === "Due").length;

    setAllInvoiceCount(allCount);
    setPaidInvoiceCount(paidCount);
    setUnpaidInvoiceCount(unpaidCount);
    setDueInvoiceCount(draftCount);

    let filteredData: typeof searchedData = [];
    if (instalmentFilterState === "All") {
      filteredData = searchedData;
    } else {
      filteredData = searchedData.filter(
        (i) => i.status === instalmentFilterState
      );
    }

    setFilteredInstalmentData(filteredData);
  }, [instalmentData, instalmentFilterState, instalmentSearchKey]);


  /* ******************************* Instalment ******************************* */
  const handleSwitchInstalmentFilterState = (
    state: "All" | "Paid" | "Unpaid" | "Draft"
  ) => {
    setInstalmentFilterState(state);
    setInstalmentSearchKey("");
    goToTop();
  };

  const handleClosePaymentmodal = () => {
    setShowPaymentmodal(false);
    handleClearPaymentFields(false);
    handleClearPaymentErrors();
  };

  const handleClearPaymentFields = (options: boolean) => {
    if (options) {
      setSelectedProject(selectedProject);
    } else {
      setSelectedProject(null);
    }

    setInvoiceNumber('');
    setInstalmentAmount(null);
    setInvoiceDate(null);
    setPaymentDate(null);
    setInvoiceFileURL(null);
  };

  const handleClearPaymentErrors = () => {
    setProjectError("");
    setInstalmentAmountError("");
    setInvoiceDateError("");
    setPaymentDateError("");
    setInvoiceNumberError("");
    setInvoiceFileURLError("");
  };

  const handleAddInstalment = () => {
    setShowPaymentmodal(true);
    setDataState("Add");
  };

  useEffect(() => {
    checkModelSelected(selectedProject !== null, false, setProjectError);
  }, [selectedProject]);

  useEffect(() => {
    checkText(invoiceNumber, false, setInvoiceNumberError);
  }, [invoiceNumber]);

  useEffect(() => {
    checkText(formatDate(invoiceDate!), false, setInvoiceDateError);
  }, [invoiceDate]);

  useEffect(() => {
    checkText(formatDate(paymentDate!), false, setPaymentDateError);
  }, [paymentDate]);

  useEffect(() => {
    checkNumber(instalmentAmount!, false, setInstalmentAmountError);
  }, [instalmentAmount]);

  useEffect(() => {
    checkText((invoiceFileURL ?? ''), false, setInvoiceFileURLError);
  }, [invoiceFileURL]);

  function checkCredentials(): boolean {
    const isValidProject = checkModelSelected(selectedProject !== null, true, setProjectError);
    const isValidInvoiceNumber = checkText(invoiceNumber, true, setInvoiceNumberError);
    const isValidInvoiceDate = checkText(formatDate(invoiceDate!), true, setInvoiceDateError);
    const isValidDueDate = checkText(formatDate(paymentDate!), true, setPaymentDateError);
    const isValidAmount = checkNumber(instalmentAmount!, true, setInstalmentAmountError);
    const isValidInvoiceFileUrl = checkText((invoiceFileURL ?? ''), true, setInvoiceFileURLError);

    return (
      isValidProject &&
      isValidInvoiceNumber &&
      isValidInvoiceDate &&
      isValidDueDate &&
      isValidAmount &&
      isValidInvoiceFileUrl
    )
  }

  //   database function for create an installment.
  const handleCreateInstalment = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!checkCredentials()) return;

    setLoading(true);

    try {
      const data = await createInstalmentService(
        selectedProject?.project_id!,
        invoiceNumber,
        instalmentAmount!,
        formatDate(invoiceDate!),
        formatDate(paymentDate!),
        ''
      );

      if (data.statusCode === 200) {
        fetchPaymentInstalmentsData();
        handleClosePaymentmodal();

        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Invoice created successfully.",
          life: 3000,
        });
      } else {
        toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating the invoice.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error creating the invoice:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while creating the invoice.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditInstalment = (data: Instalment) => {
    if (!data) return;

    setSelectedInstalment(data);
    setShowPaymentmodal(true);
    setDataState("Edit");
    setOpenMenuId(null);

    const project = projectsData?.find(
      (project) => project?.project_id === data?.project_id
    );

    setSelectedProject(project || null);
    setInvoiceNumber(String(data?.invoice_no) ?? '');
    setInstalmentAmount(data?.amount || null);
    setInvoiceDate(data?.invoice_date ? new Date(data?.invoice_date) : null);
    setPaymentDate(data?.due_date ? new Date(data?.due_date) : null);
    setInvoiceFileURL(data?.invoice ?? null);
  };

  useEffect(() => {
    if (!selectedInstalment) return;

    if (selectedProject?.project_id !== selectedInstalment?.project_id) {
      setUpdateHasChanges(true);
    } else if (invoiceNumber !== null && invoiceNumber !== String(selectedInstalment?.invoice_no)) {
      setUpdateHasChanges(true);
    } else if (instalmentAmount !== null && instalmentAmount !== selectedInstalment?.amount) {
      setUpdateHasChanges(true);
    } else if (format(invoiceDate!, "MMMM dd, yyyy") !== selectedInstalment?.invoice_date) {
      setUpdateHasChanges(true);
    } else if (format(paymentDate!, "MMMM dd, yyyy") !== selectedInstalment?.due_date) {
      setUpdateHasChanges(true);
    } else if (invoiceFileURL !== null && invoiceFileURL !== selectedInstalment?.invoice) {
      setUpdateHasChanges(true);
    } else {
      setUpdateHasChanges(false);
    }
  }, [selectedInstalment, selectedProject, invoiceNumber, instalmentAmount, invoiceDate, paymentDate, invoiceFileURL]);

  //   update database functions ass well.
  const handleUpdateInstalment = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!checkCredentials() || !selectedInstalment) return;

    setLoading(true);

    try {
      const data = await updateInstalmentService(
        selectedInstalment?.instalment_id,
        invoiceNumber,
        instalmentAmount!,
        formatDate(invoiceDate!),
        formatDate(paymentDate!),
        selectedProject?.project_id!,
        invoiceFileURL!,
      );

      if (data.statusCode === 200) {
        fetchPaymentInstalmentsData();
        handleClosePaymentmodal();

        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Invoice updated successfully.",
          life: 3000,
        });
      } else {
        toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error updating the Invoice.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating the Invoice:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while updating the Invoice.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteInstalment = (data: Instalment) => {
    const instalmentId = data?.instalment_id;
    setOpenMenuId(null);

    confirmDialog({
      message: "Are you sure you want to delete this instalment record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteInstalment(instalmentId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteInstalment = async (instalmentId: number) => {
    if (!instalmentId) return;

    try {
      const result = await deleteInstalmentService(instalmentId);

      if (result.statusCode === 200) {
        fetchPaymentInstalmentsData();

        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Invoice record deleted successfully.",
          life: 3000,
        });
      } else {
        toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the invoice.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error deleting the invoice:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while deleting the invoice.",
        life: 3000,
      });
    }
  };

  const paymentModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} invoice</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleClosePaymentmodal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const paymentModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleClosePaymentmodal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateInstalment : handleUpdateInstalment}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const jobNoBodyTemplate = (rowData: Instalment) => {
    return (
      <span className="text_bold">
        <span>{rowData.job_number}</span>
        <small className="table_data_sub text-capitalize">
          {rowData.address}
        </small>
      </span>
    );
  };

  const statusBodyTemplate = (rowData: Instalment) => {
    const status = rowData.status;
    let colorCode = "";

    if (status === "Paid") {
      colorCode = "#20c58e";
    } else if (status === "Unpaid") {
      colorCode = "#f3bc6a";
    } else if (status === "Due") {
      colorCode = "#b4b4b4";
    }

    return (
      <div className="flex_center">
        <span className="priority_label" style={{ backgroundColor: colorCode }}>
          {status}
        </span>
      </div>
    );
  };

  const handleViewInstalment = (data: Instalment) => {
    if (data) {
      setSelectedInstalment(data);
      setShowInstalmentViewModal(true);
      setOpenMenuId(null);
    } else {
      setSelectedInstalment(null);
    }
  };

  const handleCloseInstalmentViewModal = () => {
    setShowInstalmentViewModal(false);
    setSelectedInstalment(null);
  };

  const instalmentViewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Invoice details</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseInstalmentViewModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const tableActionMenuItems: MenuItem[] = [
    {
      items: [
        {
          label: "View",
          command: () => {
            if (selectedInstalment !== null) {
              handleViewInstalment(selectedInstalment);
            }
          },
        },

        {
          label: "Edit",
          command: () => {
            if (selectedInstalment !== null) {
              handleEditInstalment(selectedInstalment);
            }
          },
        },

        {
          label: "Delete",
          command: () => {
            if (selectedInstalment !== null) {
              handleDeleteInstalment(selectedInstalment);
            }
          },
        },
      ].filter((e) => (e.label === "Edit" && hasPermissionEditInvoice) || (e.label === "Delete" && hasPermissionDeleteInvoice) || (e.label === "View")),
    },
  ];

  const tableActionMenuToggle = (
    e: React.MouseEvent<HTMLButtonElement>,
    data: Instalment
  ) => {
    e.stopPropagation();
    setSelectedInstalment(data);

    if (openMenuId === data?.instalment_id) {
      menuRefs.current[data?.instalment_id]?.hide(e);
      setOpenMenuId(null);
    } else {
      if (openMenuId !== null && menuRefs.current[openMenuId]) {
        menuRefs.current[openMenuId]?.hide(e);
      }
      menuRefs.current[data?.instalment_id!]?.toggle(e);
      setOpenMenuId(data?.instalment_id!);
    }
  };

  const tableActionBody = (rowData: Instalment) => {
    return (
      <React.Fragment>
        <Button
          ref={(el) => (buttonRefs.current[rowData?.instalment_id as number] = el as HTMLButtonElement | null)}
          key={`menu_toggle_button_${rowData?.instalment_id}`}
          id={`menu_toggle_button_${rowData?.instalment_id}`}
          icon="bi bi-three-dots-vertical"
          className="is_btn action_trigger_btn p-ripple"
          onClick={(e) => tableActionMenuToggle(e, rowData)}
          aria-controls={`popup_menu_${rowData?.instalment_id}`}
          aria-haspopup
        />

        <Menu
          ref={(el) => (menuRefs.current[rowData?.instalment_id!] = el)}
          id={`popup_menu_${rowData?.instalment_id}`}
          key={`popup_menu_${rowData?.instalment_id}`}
          model={tableActionMenuItems}
          popup
          appendTo={document.body}
          className="service_action_menu"
        />
      </React.Fragment>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (openMenuId !== null) {
        const menuElement = menuRefs.current[openMenuId]?.getElement();
        const buttonElement = buttonRefs.current[openMenuId];

        if (
          menuElement &&
          !menuElement.contains(event.target as Node) &&
          buttonElement &&
          !buttonElement.contains(event.target as Node)
        ) {
          const syntheticEvent = {
            stopPropagation: () => { },
            preventDefault: () => { },
          } as React.SyntheticEvent;
          menuRefs.current[openMenuId]?.hide(syntheticEvent);
          setOpenMenuId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuId]);

  const daysCountBody = (rowData: Instalment) => {
    if (!rowData.due_date) {
      return <span className="count_label mt-1 mb-1"></span>;
    }

    const dataStatus = rowData.status;
    const today = new Date();

    const dataDueDate = new Date(Date.parse(rowData.due_date));

    if (isNaN(dataDueDate.getTime())) {
      return <span className="count_label mt-1 mb-1"></span>;
    }

    const timeDiff = dataDueDate.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return (
      <div className="flex_center">
        <Tooltip
          key={`show_info_${rowData?.instalment_id}`}
          id={`show_info_${rowData?.instalment_id}`}
          target={`.show_info_${rowData?.instalment_id}`}
        />

        {dataStatus === "Unpaid" ? (
          <span
            className={`count_label show_info_${rowData?.instalment_id} mt-1 mb-1`}
            style={{ backgroundColor: "#EF9A9A" }}
            data-pr-tooltip={`${daysDiff} day${daysDiff > 1 ? "s" : ""} left from today`}
            data-pr-position="left"
          >
            {daysDiff > 0 ? "+" : ""}
            {daysDiff}
          </span>
        ) : (
          <span className="count_label mt-1 mb-1"></span>
        )}
      </div>
    );
  };

  const handleProjectChange = (e: DropdownChangeEvent) => {
    const selectedOption = e.value as Project | null;
    setSelectedProject(selectedOption);
  };

  const selectedProjectTemplate = (option: Project, props: DropdownProps) => {
    if (option) {
      return (
        <div className="d-flex align-items-center overflow-hidden">
          <div>
            <b>{option?.job_number}</b>&nbsp;-&nbsp;{option?.address}
          </div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const projectOptionTemplate = (option: Project) => {
    return (
      <div
        className={`address_option_container ${option?.project_type === "CP" ? "bg-blue" : "bg-purple"}`}
      >
        <span>
          <b>{option?.job_number}</b>:&nbsp;
          {option?.address}
        </span>
      </div>
    );
  };

  const handleinstalmentAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setInstalmentAmount(e.value);
    }
  };

  const handleViewInvoiceFile = () => {
    setShowInvoiceViewModal(true);
  };

  const viewInstalmentStatus = (status: "Paid" | "Unpaid" | "Due") => {
    let colorCode = "";
    let icon = "";

    if (status === "Paid") {
      colorCode = "#20c58e";
      icon = "bi bi-check-circle";
    } else if (status === "Unpaid") {
      colorCode = "#f3bc6a";
      icon = "bi bi-clock";
    } else if (status === "Due") {
      colorCode = "#b4b4b4";
      icon = "bi bi-file-earmark-minus";
    }

    return (
      <span className="priority_label" style={{ backgroundColor: colorCode }}>
        <i className={`${icon} me-2`}></i>
        {status}
      </span>
    );
  };
  /* *************************************************************************** */

  /* ***************************** Common function ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {dataLoading && initialDataloading ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="main_heading">Invoice</h4>

              <GoBackButton />
            </div>

            <div className="page_header_area end_flex mt-sm-3 mt-3">
              <div className="payment_filter_tabs_area">
                <button
                  className={`payment_filter_tab primary ${instalmentFilterState === "All" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("All")}
                >
                  <i className="bi bi-receipt payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">All</span>
                    <span className="payment_filter_count">
                      {String(allInvoiceCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(128, 100, 209, 0.2)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab success ${instalmentFilterState === "Paid" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Paid")}
                >
                  <i className="bi bi-check-circle payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Paid</span>
                    <span className="payment_filter_count">
                      {String(paidInvoiceCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple
                    pt={{ root: { style: { background: "rgba(32, 197, 142, 0.2)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab warning ${instalmentFilterState === "Unpaid" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Unpaid")}
                >
                  <i className="bi bi-clock payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Unpaid</span>
                    <span className="payment_filter_count">
                      {String(unpaidInvoiceCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(243, 188, 106, 0.3)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab secondary ${instalmentFilterState === "Draft" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Draft")}
                >
                  <i className="bi bi-file-earmark-minus payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Due</span>
                    <span className="payment_filter_count">
                      {String(dueInvoiceCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(180, 180, 180, 0.3)" } } }} />
                </button>
              </div>

              <div className="page_action_area wrap_flex">
                <div className="filter_input_group">
                  <IconField iconPosition="right">
                    {instalmentSearchKey === "" ? (
                      <InputIcon className="bi bi-search"></InputIcon>
                    ) : (
                      <InputIcon
                        className="bi bi-x-lg search_clear_icon"
                        onClick={() => setInstalmentSearchKey("")}
                      ></InputIcon>
                    )}

                    <InputText
                      key={`instalmentSearchKey`}
                      id="instalmentSearchKey"
                      value={instalmentSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInstalmentSearchKey(e.target.value)}
                      className="custom_form_input filter_input auto_width"
                      placeholder="Search by address/job no."
                      type="search"
                    />
                  </IconField>
                </div>

                {(hasPermissionAddInvoice) && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddInstalment}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add invoice</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_main_content_section p-0">
              {instalmentData && instalmentData?.length > 0 ? (
                <DataTable
                  value={filteredInstalmentData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No records found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: "50rem", maxHeight: '55vh' }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table p-0 p-sm-2"
                  rowHover
                  scrollable
                  loading={dataLoading}
                  scrollHeight="55vh"
                >
                  <Column
                    header="Job No."
                    field="job_number"
                    headerClassName="text_purple"
                    alignHeader={"left"}
                    body={jobNoBodyTemplate}
                    style={{ width: "1  5%" }}
                  ></Column>

                  <Column
                    header="Invoice date"
                    headerClassName="text_purple"
                    field="invoice_date"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap">
                        {rowData?.invoice_date ? rowData?.invoice_date : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Due date"
                    headerClassName="text_purple"
                    field="due_date"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap">
                        {rowData?.due_date ? rowData?.due_date : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Amount"
                    headerClassName="text_purple"
                    alignHeader={"right"}
                    field="amount"
                    className="text_bold"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap flex_end">
                        {currencySymbol}&nbsp;
                        {rowData?.amount ? rowData?.amount.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Status"
                    alignHeader={"center"}
                    field="status"
                    headerClassName="text_purple"
                    body={statusBodyTemplate}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    body={daysCountBody}
                    style={{ width: "5%" }}
                  ></Column>

                  <Column
                    body={tableActionBody}
                    style={{ width: "5%" }}
                    frozen
                    alignFrozen="right"
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated
                  message={`No invoice(s) data found. ${hasPermissionAddInvoice ? 'To add, click on the Add button.' : ''}`}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Payment modal */}
      <Dialog
        visible={showPaymentModal}
        headerClassName="custom_modal_header"
        header={paymentModalHeader}
        footer={paymentModalFooter}
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleClosePaymentmodal}
        dismissableMask
        closeOnEscape={false}
        contentClassName={`${dataState === "Add" && "pb-0"}`}
        ref={dialogRef}
      >
        <div className="custom_modal_body pb-0">
          <div className="p-1 pt-2 pb-0 p-sm-4 pt-sm-2 pb-sm-0 w-100">
            <div className="row">
              {/* Project */}
              <div className="col-12">
                <div className="page_form_group">
                  <label htmlFor="Project" className="custom_form_label is_required">
                    Project
                  </label>

                  <Dropdown
                    key={`Project`}
                    id="Project"
                    value={selectedProject}
                    onChange={handleProjectChange}
                    options={projectsData}
                    optionLabel="job_number"
                    valueTemplate={selectedProjectTemplate}
                    itemTemplate={projectOptionTemplate}
                    emptyFilterMessage="No project(s) found!"
                    placeholder="Select project"
                    className="form_dropdown address_selection w-100"
                    filter
                    showClear
                    filterInputAutoFocus
                    filterBy="job_number,address"
                    filterPlaceholder="Search by address/job no."
                    panelClassName="address_dropdown_panel"
                    loading={loadingProjects}
                  />

                  {projectError && (
                    <small className="form_error_msg">{projectError}</small>
                  )}
                </div>
              </div>

              {/* Invoice number */}
              <div className="col-12 col-sm-6">
                <TextInput
                  id="invoiceNumber"
                  label="Invoice number"
                  labelHtmlFor="invoiceNumber"
                  required={true}
                  value={invoiceNumber}
                  placeholder="Invoice number"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInvoiceNumber(e.target.value)}
                  error={invoiceNumberError}
                />
              </div>

              {/* Amount */}
              <div className="col-12 col-sm-6">
                <NumberInput
                  key={`instalmentAmount`}
                  inputId="instalmentAmount"
                  label="Amount"
                  labelHtmlFor="instalmentAmount"
                  placeholder="Enter amount"
                  onChange={handleinstalmentAmountChange}
                  value={instalmentAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  prefix={currencySymbol + " "}
                  error={instalmentAmountError}
                />
              </div>

              {/* Invoice date */}
              <div className="col-12 col-sm-6">
                <DatePicker
                  key={`invoiceDate`}
                  id="invoiceDate"
                  label="Invoice date"
                  labelHtmlFor="invoiceDate"
                  required={true}
                  value={invoiceDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setInvoiceDate}
                  error={invoiceDateError}
                  showClear
                  onClear={() => setInvoiceDate(null)}
                />
              </div>

              {/* Due date */}
              <div className="col-12 col-sm-6">
                <DatePicker
                  key={`paymentDate`}
                  id="paymentDate"
                  label="Due date"
                  labelHtmlFor="paymentDate"
                  required={true}
                  value={paymentDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setPaymentDate}
                  error={paymentDateError}
                  showClear
                  onClear={() => setPaymentDate(null)}
                />
              </div>

              <div className="col-12 pb-1">
                <div className="note_text_label mb-4">
                  <span>Note:</span>

                  <ul className="note_text_content">
                    <li>We will start work once you have paid.</li>
                    <li>The start date will be the payment date.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Instalment view modal */}
      <Dialog
        visible={showInstalmentViewModal}
        header={instalmentViewModalHeader}
        headerClassName="custom_modal_header"
        className={`custom_modal_dialog modal_dialog_sm`}
        onHide={handleCloseInstalmentViewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1">
            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Project:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content text_purple">
                  {selectedInstalment?.job_number}:{" "} {selectedInstalment?.address}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Invoice number:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.invoice_no ? selectedInstalment?.invoice_no : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Amount:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {currencySymbol}&nbsp;
                  {selectedInstalment?.amount ? selectedInstalment?.amount?.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Invoice date:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.invoice_date ? selectedInstalment?.invoice_date : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Due date:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.due_date ? selectedInstalment?.due_date : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">File:</h6>
              </div>
              <div className="col-7">
                {selectedInstalment?.invoice !== null ? (
                  <button
                    className="data_file_view_button is_btn p-ripple"
                    onClick={handleViewInvoiceFile}
                  >
                    <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                    {selectedInstalment?.invoice?.split("/").pop()}
                    <Ripple />
                  </button>
                ) : (
                  <p className="data_view_detail text_italic">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    No file uploaded!
                  </p>
                )}
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Status:</h6>
              </div>
              <div className="col-7">
                {viewInstalmentStatus(selectedInstalment?.status!)}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Invoice file view modal */}
      <DocumentViewModal
        isOpen={showInvoiceViewModal}
        fileUrl={baseURL + selectedInstalment?.invoice}
        onClose={() => setShowInvoiceViewModal(false)}
      />
      {/*  */}
    </React.Fragment>
  );
};

export default Payment;
